import type { NodeTrackingPayload } from '@getaccept/lib-shared/src/tracking/types/node-tracking-payload';
import type { SectionTrackingPayload } from '@getaccept/lib-shared/src/tracking/types/section-tracking-payload';
import { apolloClient } from '../../apollo';
import { TrackingMutations } from '../graphql/tracking.mutations';

export class TrackingService {
  static async trackEditor(
    sections: SectionTrackingPayload[],
    nodes: NodeTrackingPayload[]
  ): Promise<boolean> {
    const {
      data: { trackEditor },
    } = await apolloClient.mutate({
      mutation: TrackingMutations.trackEditorBlock,
      variables: {
        sections,
        nodes,
      },
    });
    return trackEditor;
  }
}
